module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Fullname":"Full name","labelGender":"Gender","labelHomePhone":"Phone","labelEmergencyPhone":"Emergency phone"},"es":{"Fullname":"Nombre completo","labelGender":"Género","labelHomePhone":"Teléfono","labelEmergencyPhone":"Teléfono de emergencias"}}')
  delete Component.options._Ctor
}
